import { patchRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function updateTripTemplateRequest(id, patch) {
	let url = tripTemplates.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}

